import { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { formatNumber } from '../../../../../utils/formatacoes';

const TotaisTributosTable = ({ tributos, totais }) => {
  const [rows, setRows] = useState([]);

  const columns = [
    {
      id: 'apelido',
      name: 'Tributo',
      selector: (row) => row.apelido,
    },
    {
      id: 'valor_calculado',
      name: 'Calculado R$',
      right: true,
      selector: (row) => formatNumber(row.valor_calculado),
    },
    {
      id: 'valor_reduzido',
      name: 'Reduzido R$',
      right: true,
      selector: (row) => formatNumber(row.valor_reduzido),
    },
    {
      id: 'valor_devido',
      name: 'Devido R$',
      right: true,
      selector: (row) => formatNumber(row.valor_devido),
    },
    {
      id: 'valor_suspenso',
      name: 'Suspenso R$',
      right: true,
      selector: (row) => formatNumber(row.valor_suspenso),
    },
    {
      id: 'valor_recolher',
      name: 'A Recolher R$',
      right: true,
      selector: (row) => formatNumber(row.valor_recolher),
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => row.isTotal,
      style: { fontWeight: 'bold' },
    },
  ];

  useEffect(() => {
    if (!tributos || tributos.length === 0) {
      setRows([]);
      return;
    }

    setRows([...tributos, { apelido: 'TOTAL', isTotal: true, ...totais }]);
  }, [tributos, totais]);

  return (
    <Fragment>
      <DataTable
        dense
        keyField='apelido'
        columns={columns}
        data={rows}
        conditionalRowStyles={conditionalRowStyles}
        noDataComponent='Nenhum registro encontrado.'
      />
    </Fragment>
  );
};

export default TotaisTributosTable;